import React, { Component } from 'react';
import { getAuthorizationProvider } from './AuthorizationProvider';

let authorizationProvider;

export function withAuth(HocComponent) {
  // eslint-disable-next-line react/display-name
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isAuthenticated: false,
        user: {},
        hasError: false,
        errorMessage: null
      };
    }

    async UNSAFE_componentWillMount() {
      authorizationProvider = await getAuthorizationProvider();
      try {
        // MSAL v3: Use handleRedirectPromise for redirect handling
        const response = await authorizationProvider.handleRedirectPromise();
        if (response && response.account) {
          this.setState({
            isAuthenticated: true,
            user: response.account
          });
        } else {
          // Try to get an active account
          const accounts = authorizationProvider.getAllAccounts();
          if (accounts && accounts.length > 0) {
            this.setState({
              isAuthenticated: true,
              user: accounts[0]
            });
          } else {
            authorizationProvider.loginRedirect({});
          }
        }
      } catch (authErr) {
        console.log(authErr);
        this.setState({
          hasError: true,
          errorMessage: authErr.errorMessage || authErr.message
        });
      }
    }

    onSignIn() {
      authorizationProvider.loginRedirect({});
    }

    onSignOut() {
      authorizationProvider.logout();
    }

    render() {
      if (this.state.isAuthenticated) {
        return (
          <HocComponent
            auth={this.state}
            onSignIn={() => this.onSignIn()}
            onSignOut={() => this.onSignOut()}
            {...this.props}
          />
        );
      }
      if (this.state.hasError) {
        return <div>{this.state.errorMessage}</div>;
      }
      return <div>Login in progress...</div>;
    }
  };
}
